<script setup lang="ts">
import type { StickerTypeFragment } from '~~layers/.nuxt/graphql-operations'

const { sticker } = defineProps<{
  sticker: StickerTypeFragment
}>()
</script>

<template>
  <div
    v-if="sticker?.Image?.url && sticker?.ImageMobile?.url"
    class="sticker"
  >
    <img
      :src="useXcdnImage(sticker.Image.url, 'f=rs:fit:1280')"
      :alt="sticker.Title || ''"
      class="sticker__image sticker__image--large"
      height="160"
      width="160"
      loading="lazy"
      fetchpriority="low"
      decoding="async"
    >

    <img
      :src="useXcdnImage(sticker.ImageMobile.url, 'f=rs:fit:1280')"
      :alt="sticker.Title || ''"
      class="sticker__image sticker__image--medium"
      height="104"
      width="104"
      loading="lazy"
      fetchpriority="low"
      decoding="async"
    >
  </div>
</template>

<style>
@import url("~layers/components/Strapi/Sticker.css");
</style>
